import { Link } from 'react-router-dom';

export default function IzakayaNightBanner() {
  return (
    <section className="py-16 px-4 bg-gradient-to-br from-amber-950 via-orange-950 to-amber-950 relative overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-amber-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-600 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="bg-gradient-to-r from-amber-900/90 to-orange-900/90 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-amber-600/30 shadow-2xl">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">

            {/* 左側：テキストコンテンツ */}
            <div className="flex-1 text-center lg:text-left">
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4">
                <div className="inline-flex items-center gap-2 bg-amber-600/20 border border-amber-600/50 rounded-full px-4 py-1.5">
                  <i className="ri-beer-line text-amber-400 text-lg"></i>
                  <span className="text-amber-400 text-sm font-semibold">Local Experience</span>
                </div>
                <div className="inline-flex items-center gap-1.5 bg-orange-600/80 rounded-full px-3 py-1.5">
                  <i className="ri-group-line text-white text-sm"></i>
                  <span className="text-white text-xs font-bold">Max 4 People</span>
                </div>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                🍻 Tokyo Local Izakaya Night
              </h2>

              <p className="text-gray-300 text-base md:text-lg mb-6 leading-relaxed">
                Experience Tokyo like a local friend<br className="hidden md:block" />
                <span className="text-amber-400 font-semibold">Staying in Tokyo? Join us for an authentic izakaya experience!</span>
              </p>

              {/* 料金カード */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4 max-w-md mx-auto lg:mx-0">
                <div className="bg-gradient-to-b from-amber-900/80 to-orange-900/80 border border-amber-500 rounded-xl px-4 py-4 text-center relative">
                  <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-amber-500 text-black text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap">Base Price</div>
                  <div className="text-gray-400 text-xs mb-1">3 Hours Experience</div>
                  <div className="text-amber-400 text-2xl font-extrabold">¥20,000〜</div>
                  <div className="text-gray-500 text-xs mt-1">Relaxed atmosphere</div>
                </div>
                <div className="bg-gradient-to-b from-gray-800/80 to-black/80 border border-amber-600/40 rounded-xl px-4 py-4 text-center hover:border-amber-500 transition-colors">
                  <div className="text-gray-400 text-xs mb-1">Additional Guest</div>
                  <div className="text-amber-400 text-2xl font-extrabold">+¥6,000</div>
                  <div className="text-gray-500 text-xs mt-1">Per person</div>
                </div>
              </div>

              {/* 注記 */}
              <p className="text-gray-500 text-xs mb-5 text-center lg:text-left">
                ※ Food &amp; drinks paid directly at each venue &nbsp;※ Not a transportation service
              </p>

              {/* 特徴リスト */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-4 mb-7">
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-user-smile-line text-amber-400"></i>
                  <span>Like a Local Friend</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-restaurant-line text-amber-400"></i>
                  <span>Authentic Izakayas</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-chat-smile-3-line text-amber-400"></i>
                  <span>Casual &amp; Relaxed</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-team-line text-amber-400"></i>
                  <span>Small Groups Only</span>
                </div>
              </div>

              {/* CTAボタン */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-3">
                <Link
                  to="/tokyo-izakaya-night-en"
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-600 to-orange-500 hover:from-amber-500 hover:to-orange-400 text-black font-bold px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-amber-500/50 whitespace-nowrap"
                >
                  <span>View Details &amp; Book</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </Link>
                <Link
                  to="/tokyo-izakaya-night"
                  className="inline-flex items-center gap-2 bg-transparent border border-amber-600/60 hover:border-amber-500 text-amber-400 hover:text-amber-300 font-semibold px-6 py-4 rounded-full transition-all duration-300 whitespace-nowrap"
                >
                  <i className="ri-translate"></i>
                  <span>日本語ページ</span>
                </Link>
              </div>
            </div>

            {/* 右側：イメージ */}
            <div className="flex-shrink-0 w-full lg:w-80 h-64 lg:h-96 rounded-xl overflow-hidden shadow-2xl border border-amber-600/30">
              <img
                src="https://public.readdy.ai/ai/img_res/4531d3eab10d455ad235c7112e24d607.jpg"
                alt="Tokyo Local Izakaya Night"
                className="w-full h-full object-cover object-top"
              />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}